var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5996 0C12.2621 0 12.0371 0.225 12.0371 0.5625V17.4375C12.0371 17.775 12.2621 18 12.5996 18C12.9371 18 13.1621 17.775 13.1621 17.4375V0.5625C13.1621 0.225 12.9371 0 12.5996 0Z",
    fill: "#808285"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6623 0C8.3248 0 8.0998 0.225 8.0998 0.5625V8.4375H2.3623L4.0498 6.75C4.2748 6.525 4.2748 6.1875 4.0498 5.9625C3.8248 5.7375 3.4873 5.7375 3.2623 5.9625L0.562305 8.6625C0.337305 8.8875 0.337305 9.225 0.562305 9.45L3.2623 12.15C3.3748 12.2625 3.4873 12.375 3.7123 12.375C3.8248 12.375 4.0498 12.2625 4.1623 12.15C4.3873 11.925 4.3873 11.5875 4.1623 11.3625L2.2498 9.5625H7.9873V17.4375C7.9873 17.775 8.2123 18 8.5498 18C8.8873 18 9.1123 17.775 9.1123 17.4375V0.5625C9.2248 0.225 8.9998 0 8.6623 0Z",
    fill: "#808285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.2a4f9cba25f5c3f3d1a574e2598d8ffc.svg";
export { ForwardRef as ReactComponent };